import Bundles from "./bundles.container";

export default Bundles;
